// source: async_job.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.filesync_daemon.AsyncJob', null, global);
goog.exportSymbol('proto.filesync_daemon.AsyncJob.Status', null, global);
goog.exportSymbol('proto.filesync_daemon.AsyncJob.Type', null, global);
goog.exportSymbol('proto.filesync_daemon.CloudEvent', null, global);
goog.exportSymbol('proto.filesync_daemon.EventType', null, global);
goog.exportSymbol('proto.filesync_daemon.Notification', null, global);
goog.exportSymbol('proto.filesync_daemon.Notification.Type', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filesync_daemon.Notification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.filesync_daemon.Notification.repeatedFields_, null);
};
goog.inherits(proto.filesync_daemon.Notification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filesync_daemon.Notification.displayName = 'proto.filesync_daemon.Notification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filesync_daemon.CloudEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.filesync_daemon.CloudEvent.repeatedFields_, null);
};
goog.inherits(proto.filesync_daemon.CloudEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filesync_daemon.CloudEvent.displayName = 'proto.filesync_daemon.CloudEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filesync_daemon.AsyncJob = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.filesync_daemon.AsyncJob, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filesync_daemon.AsyncJob.displayName = 'proto.filesync_daemon.AsyncJob';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.filesync_daemon.Notification.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filesync_daemon.Notification.prototype.toObject = function(opt_includeInstance) {
  return proto.filesync_daemon.Notification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filesync_daemon.Notification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.Notification.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    asyncJobsList: jspb.Message.toObjectList(msg.getAsyncJobsList(),
    proto.filesync_daemon.AsyncJob.toObject, includeInstance),
    cloudEventsList: jspb.Message.toObjectList(msg.getCloudEventsList(),
    proto.filesync_daemon.CloudEvent.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filesync_daemon.Notification}
 */
proto.filesync_daemon.Notification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filesync_daemon.Notification;
  return proto.filesync_daemon.Notification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filesync_daemon.Notification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filesync_daemon.Notification}
 */
proto.filesync_daemon.Notification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.filesync_daemon.Notification.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.filesync_daemon.AsyncJob;
      reader.readMessage(value,proto.filesync_daemon.AsyncJob.deserializeBinaryFromReader);
      msg.addAsyncJobs(value);
      break;
    case 3:
      var value = new proto.filesync_daemon.CloudEvent;
      reader.readMessage(value,proto.filesync_daemon.CloudEvent.deserializeBinaryFromReader);
      msg.addCloudEvents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filesync_daemon.Notification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filesync_daemon.Notification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filesync_daemon.Notification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.Notification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.filesync_daemon.Notification.Type} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getAsyncJobsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.filesync_daemon.AsyncJob.serializeBinaryToWriter
    );
  }
  f = message.getCloudEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.filesync_daemon.CloudEvent.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.filesync_daemon.Notification.Type = {
  UNKNOWN: 0,
  ASYNCJOB: 1,
  CRUD: 2
};

/**
 * required Type type = 1;
 * @return {!proto.filesync_daemon.Notification.Type}
 */
proto.filesync_daemon.Notification.prototype.getType = function() {
  return /** @type {!proto.filesync_daemon.Notification.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.filesync_daemon.Notification.Type} value
 * @return {!proto.filesync_daemon.Notification} returns this
 */
proto.filesync_daemon.Notification.prototype.setType = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.Notification} returns this
 */
proto.filesync_daemon.Notification.prototype.clearType = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.Notification.prototype.hasType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AsyncJob async_jobs = 2;
 * @return {!Array<!proto.filesync_daemon.AsyncJob>}
 */
proto.filesync_daemon.Notification.prototype.getAsyncJobsList = function() {
  return /** @type{!Array<!proto.filesync_daemon.AsyncJob>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.filesync_daemon.AsyncJob, 2));
};


/**
 * @param {!Array<!proto.filesync_daemon.AsyncJob>} value
 * @return {!proto.filesync_daemon.Notification} returns this
*/
proto.filesync_daemon.Notification.prototype.setAsyncJobsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.filesync_daemon.AsyncJob=} opt_value
 * @param {number=} opt_index
 * @return {!proto.filesync_daemon.AsyncJob}
 */
proto.filesync_daemon.Notification.prototype.addAsyncJobs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.filesync_daemon.AsyncJob, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.filesync_daemon.Notification} returns this
 */
proto.filesync_daemon.Notification.prototype.clearAsyncJobsList = function() {
  return this.setAsyncJobsList([]);
};


/**
 * repeated CloudEvent cloud_events = 3;
 * @return {!Array<!proto.filesync_daemon.CloudEvent>}
 */
proto.filesync_daemon.Notification.prototype.getCloudEventsList = function() {
  return /** @type{!Array<!proto.filesync_daemon.CloudEvent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.filesync_daemon.CloudEvent, 3));
};


/**
 * @param {!Array<!proto.filesync_daemon.CloudEvent>} value
 * @return {!proto.filesync_daemon.Notification} returns this
*/
proto.filesync_daemon.Notification.prototype.setCloudEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.filesync_daemon.CloudEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.filesync_daemon.CloudEvent}
 */
proto.filesync_daemon.Notification.prototype.addCloudEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.filesync_daemon.CloudEvent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.filesync_daemon.Notification} returns this
 */
proto.filesync_daemon.Notification.prototype.clearCloudEventsList = function() {
  return this.setCloudEventsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.filesync_daemon.CloudEvent.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filesync_daemon.CloudEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.filesync_daemon.CloudEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filesync_daemon.CloudEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.CloudEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventtype: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    colluuid: msg.getColluuid_asB64(),
    parentuuid: msg.getParentuuid_asB64(),
    entryuuid: msg.getEntryuuid_asB64(),
    fstype: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    filesize: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    pathnodesList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filesync_daemon.CloudEvent}
 */
proto.filesync_daemon.CloudEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filesync_daemon.CloudEvent;
  return proto.filesync_daemon.CloudEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filesync_daemon.CloudEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filesync_daemon.CloudEvent}
 */
proto.filesync_daemon.CloudEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.filesync_daemon.EventType} */ (reader.readEnum());
      msg.setEventtype(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setColluuid(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setParentuuid(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setEntryuuid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFstype(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFilesize(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addPathnodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filesync_daemon.CloudEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filesync_daemon.CloudEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.CloudEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.filesync_daemon.EventType} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getPathnodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
};


/**
 * required EventType eventType = 1;
 * @return {!proto.filesync_daemon.EventType}
 */
proto.filesync_daemon.CloudEvent.prototype.getEventtype = function() {
  return /** @type {!proto.filesync_daemon.EventType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.filesync_daemon.EventType} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setEventtype = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearEventtype = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasEventtype = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required bytes collUUID = 2;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.CloudEvent.prototype.getColluuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * required bytes collUUID = 2;
 * This is a type-conversion wrapper around `getColluuid()`
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getColluuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getColluuid()));
};


/**
 * required bytes collUUID = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getColluuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.getColluuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getColluuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setColluuid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearColluuid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasColluuid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bytes parentUUID = 3;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.CloudEvent.prototype.getParentuuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes parentUUID = 3;
 * This is a type-conversion wrapper around `getParentuuid()`
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getParentuuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getParentuuid()));
};


/**
 * optional bytes parentUUID = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getParentuuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.getParentuuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getParentuuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setParentuuid = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearParentuuid = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasParentuuid = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * required bytes entryUUID = 4;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.CloudEvent.prototype.getEntryuuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * required bytes entryUUID = 4;
 * This is a type-conversion wrapper around `getEntryuuid()`
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getEntryuuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getEntryuuid()));
};


/**
 * required bytes entryUUID = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEntryuuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.getEntryuuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getEntryuuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setEntryuuid = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearEntryuuid = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasEntryuuid = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * required string fsType = 5;
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getFstype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setFstype = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearFstype = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasFstype = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * required uint64 fileSize = 6;
 * @return {number}
 */
proto.filesync_daemon.CloudEvent.prototype.getFilesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setFilesize = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearFilesize = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasFilesize = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated string pathNodes = 7;
 * @return {!Array<string>}
 */
proto.filesync_daemon.CloudEvent.prototype.getPathnodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setPathnodesList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.addPathnodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearPathnodesList = function() {
  return this.setPathnodesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filesync_daemon.AsyncJob.prototype.toObject = function(opt_includeInstance) {
  return proto.filesync_daemon.AsyncJob.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filesync_daemon.AsyncJob} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.AsyncJob.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    userid: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    jobType: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    status: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    errorMessage: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    percentage: (f = jspb.Message.getOptionalFloatingPointField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filesync_daemon.AsyncJob}
 */
proto.filesync_daemon.AsyncJob.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filesync_daemon.AsyncJob;
  return proto.filesync_daemon.AsyncJob.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filesync_daemon.AsyncJob} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filesync_daemon.AsyncJob}
 */
proto.filesync_daemon.AsyncJob.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {!proto.filesync_daemon.AsyncJob.Type} */ (reader.readEnum());
      msg.setJobType(value);
      break;
    case 4:
      var value = /** @type {!proto.filesync_daemon.AsyncJob.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPercentage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filesync_daemon.AsyncJob.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filesync_daemon.AsyncJob.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filesync_daemon.AsyncJob} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.AsyncJob.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {!proto.filesync_daemon.AsyncJob.Type} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {!proto.filesync_daemon.AsyncJob.Status} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeFloat(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.filesync_daemon.AsyncJob.Type = {
  UNKNOWN: 0,
  SYNC: 1,
  SHARE: 2,
  EDIT: 3,
  SYNC_V2: 4,
  COLLECTION_RENAME: 5
};

/**
 * @enum {number}
 */
proto.filesync_daemon.AsyncJob.Status = {
  NOT_IN_DB: 0,
  QUEUED: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
  FAILED: 4,
  HARD_FAILED: 5,
  ACCESS_DENIED: 6
};

/**
 * required string requestId = 1;
 * @return {string}
 */
proto.filesync_daemon.AsyncJob.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.setRequestid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.clearRequestid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.AsyncJob.prototype.hasRequestid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required string userId = 2;
 * @return {string}
 */
proto.filesync_daemon.AsyncJob.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.setUserid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.clearUserid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.AsyncJob.prototype.hasUserid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * required Type job_type = 3;
 * @return {!proto.filesync_daemon.AsyncJob.Type}
 */
proto.filesync_daemon.AsyncJob.prototype.getJobType = function() {
  return /** @type {!proto.filesync_daemon.AsyncJob.Type} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.filesync_daemon.AsyncJob.Type} value
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.setJobType = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.clearJobType = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.AsyncJob.prototype.hasJobType = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * required Status status = 4;
 * @return {!proto.filesync_daemon.AsyncJob.Status}
 */
proto.filesync_daemon.AsyncJob.prototype.getStatus = function() {
  return /** @type {!proto.filesync_daemon.AsyncJob.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.filesync_daemon.AsyncJob.Status} value
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.AsyncJob.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string error_message = 5;
 * @return {string}
 */
proto.filesync_daemon.AsyncJob.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.setErrorMessage = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.clearErrorMessage = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.AsyncJob.prototype.hasErrorMessage = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional float percentage = 6;
 * @return {number}
 */
proto.filesync_daemon.AsyncJob.prototype.getPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.setPercentage = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.clearPercentage = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.AsyncJob.prototype.hasPercentage = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * @enum {number}
 */
proto.filesync_daemon.EventType = {
  UNKNOWN: 0,
  CREATE: 1,
  UPDATE: 2,
  DELETE: 3
};

goog.object.extend(exports, proto.filesync_daemon);
